
export default [
  {
    name: `instruction_1`,
    title: `Faites glisser votre doigt pour l'explorer à 360°.`,
  },
];
